module.exports = __webpack_public_path__ + "img/accumulator-full.425bad9c.png";